import { anatomyModule } from "./anatomy";
import { anatomy2Module } from "./anatomy2";
import { anatomy3Module } from "./anatomy3";
import { anatomy4Module } from "./anatomy4";
import { nephronModule } from "./nephron";
import { nephron2Module } from "./nephron2";
import { histologyModule } from "./histology";
import { physiologyModule } from "./physiology";
import { physiology2Module } from "./physiology2";
import { physiology3Module } from "./physiology3";
import { diseaseModule } from "./disease";
import { disease2Module } from "./disease2";
import { disease3Module } from "./disease3";
import { pharmacologyModule } from "./pharmacology";
import { pharmacology2Module } from "./pharmacology2";
import { surgeryModule } from "./surgery";
import { surgery2Module } from "./surgery2";

export const kidneyModules = [
  anatomyModule,
  anatomy2Module,
  anatomy3Module,
  anatomy4Module,
  nephronModule,
  nephron2Module,
  histologyModule,
  physiologyModule,
  physiology2Module,
  physiology3Module,
  diseaseModule,
  disease2Module,
  disease3Module,
  pharmacologyModule,
  pharmacology2Module,
  surgeryModule,
  surgery2Module,
];
